class API {
  constructor() {
    this.url =
      "https://script.google.com/macros/s/AKfycbwpWVgvwPbN-8-Yy2-PrAL8x2iFbu7yz8rWA7yQJjpCdtObQDrxtzNX1qJfoz9uLPrZKQ/exec";
  }

  async push(feedbackData) {
    const data = JSON.stringify(feedbackData);

    return fetch(this.url, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  }
}

export default API;
